export const inboxMerged = {
  inboxHeader: '收件箱',
  chatsHeader: '聊天',
  contactsHeader: '联系人',
  segmentsHeader: '分组',
  ordersHeader: '订单',
  exportStatus: '导出状态',
  tasksExport: '任务导出',
  download: '下载',
  ourAllNewOmniChannelInbox: '我们全新的全渠道收件箱！',
  allYourMessagesContactsAndLeads: '所有您的消息、联系人和潜在客户现在都在一个地方。随时进行排序和分组，助您的业务成长！',
  close: '关闭',
  takeALook: '瞧一瞧',
  inProgress: '进行中',
  appTooltip: {
    manageAllYourLeadsHere: '在此管理所有潜在客户/联系人',
    segmentYourUserLeads: '根据人口统计数据和兴趣对潜在客户/机器人用户进行分组。这将用于创建广播。',
    manageAllBotsConversationsHere: '在此管理所有机器人的对话',
    manageAllYourOrdersHere: '在此管理所有订单',
  },
  contacts: {
    seeHowToUse: '了解如何使用',
    help: '帮助',
    visitorName: '访客姓名',
    email: '电子邮件',
    phoneNumber: '电话号码',
    segment: '分组',
    status: '状态',
    tag: '标签',
    action: '操作',
    discard: '丢弃',
    addTag: '添加标签',
    loadMore: '加载更多',
    nA: '无',
    assign: '分配',
    deleteUser: '删除用户',
    areYouSureToDeleteLead: '您确定要删除此潜在客户吗？',
    twilioIntegrationNeeded: '需要Twilio集成',
    twilioIntegrationNeededDescription: 'Twilio目前未连接到您的收件箱。请进行集成以致电您的客户。',
    call: '呼叫',
    twilioMakeCall: 'Twilio已成功集成。您现在可以拨打用户的电话。',
    makeACall: '拨打电话',
    integrateNow: '立即集成',
    subscribeUser: '訂閱用戶',
    unsubscribeUser: '取消訂閱用戶',
    copy: '複製',
    noDataFound: {
      youDoNotHaveAnyContactsYet: '您还没有联系人！',
      allOfYourContactsAppearHere: '您的所有联系人将显示在此处'
    },
    placeholders: {
      searchSegmentByName: '按组名搜索',
      searchOrAddTag: '搜索或添加标签',
    },
    addContacts: {
      name: '姓名',
      email: '电子邮件',
      enterAValidEmail: '输入有效的电子邮件',
      phoneNumber: '电话号码',
      cancel: '取消',
      addContact: '添加联系人',
      placeholders: {
        enterEmailAddress: '输入电子邮件地址',
        enterUserrName: '输入用户名',
        searchCountry: '搜索国家',
        enterPhoneNumber: '输入电话号码',
      }
    }
  },
  inboxFilter: {
    applied: '已应用',
    assignTags: '分配标签',
    discard: '丢弃',
    addTag: '添加标签',
    assignSegments: '分配分组',
    filterYourLeads: '过滤您的潜在客户',
    filters: '过滤器',
    filter: '过滤',
    resetAllFilters: '重置所有过滤器',
    importContacts: '导入联系人',
    beforeYouStart: '在开始上传之前，请确保',
    point1: '1. 下载示例Excel文件。',
    point2: '2. 从第2行开始输入您的数据。',
    point3: '3. 每行将包含一个联系人的数据',
    point4: '4. 确保所有电话号码都是唯一的。',
    point5: '5. 最大文件大小上传限制为20MB',
    selectFile: '选择文件',
    clickHere: '点击此处',
    toDownloadSampleFile: '下载示例文件',
    modal: {
      closeLeads: '关闭潜在客户',
      areYouSureToselectAllLeads: '您确定要关闭所有选定的潜在客户吗？',
      assignAgent: '分配代理',
      toAssignAgentToAllLeads: '您确定要为所有选定的潜在客户分配代理吗？',
      assignTag: '分配标签',
      wantToReplacePreviouslyAssignedTagWithNew: '您确定要用新选择的标签替换先前分配的标签，以适用于所有选定的潜在客户吗？',
      deleteLeads: '删除潜在客户',
      wantToDeleteSelectedLeads: '您确定要删除所有选定的潜在客户吗？',
      exportData: '导出数据',
      exportDataBasedOn: '基于以下导出数据',
      assignSegment: '分配分组',
      wantToAssignSegmentsToSelectedLeads: '您确定要为所有选定的潜在客户分配组吗？',
      yesGoAhead: '是的，继续！',
      export: '导出'
    },
    appTooltip: {
      filterDataBasedOnPreferences: '根据您的首选项过滤数据，如标签、机器人、状态等。',
      markLeadAsClosed: '将用户/潜在客户标记为已关闭',
      assignAgentToLead: '为用户分配代理',
      assignTagToUser: '为用户分配标签',
      exportData: '导出数据',
      importContactsForWhatsappBot: '为WhatsApp机器人导入联系人',
      addWhatsappContact: '添加WhatsApp联系人',
      assignSegmentToUser: '为用户分配组',
      deleteUsers: '删除用户',
    },
    placeholders: {
      typeNameEmailPhoneNumberAndPressEnter: '键入姓名、电子邮件或电话，然后按回车',
      searchAgentByName: '按代理名搜索',
      searchOrAddTag: '搜索或添加标签',
      searchSegmentByName: '按组名搜索',
    },
    filterContainer: {
      filterOn: '过滤器启用',
      filterBy: '按',
      startFrom: '开始日期',
      tillDate: '截止日期',
      offlineOrOnline: '离线/在线',
      liveChat: '实时聊天',
      userInteractedWithBot: '与机器人互动的用户',
      discard: '丢弃',
      applyFilter: '应用过滤器',
      bots: '机器人',
      tags: '标签',
      status: '状态',
      assignedTo: '分配给',
      lastMessageBy: '最后发送消息的人',
      onlineOrOffline: '在线/离线',
      userInteracted: '用户互动',
      segments: '分组',
      lastSeenDate: '上次在线日期',
      onboardingDate: '入职日期',
      createTags: '创建标签',
      createTagsToSortAndManageLeads: '创建标签以轻松排序和管理您的潜在客户',
      typeYourTagHere: '在此键入您的标签',
      createSegment: '创建组',
      manageSegmentForMarketingAutomation: '管理您的组以进行营销自动化',
      typeYourSegmentHere: '在此键入您的组',
      unSubscribers: '未訂閱者',
      unSubscriberUsers: '已退訂用戶',
      placeholders: {
        searchFilter: '搜索过滤器',
        searchByBotName: '按机器人名称搜索',
        searchOrAddTag: '搜索或添加标签',
        searchByAgentName: '按代理名称搜索',
        searchBySegments: '按组名搜索',
      },
      appTooltip: {
        dateRangeYouWishToEndSelectionAt: '您希望结束选择的日期范围',
        dateRangeYouWishToStartSelectionFrom: '您希望开始选择的日期范围',
        filterThoseThatAreOfflineOrOnline: '过滤离线/在线的用户',
        filterThoseThatAreCurrentlyLiveChatting: '过滤当前正在进行实时聊天的用户',
        filterThoseThatInteractedWithBot: '过滤与机器人互动的用户',
        filterBySubscribers: '按訂閱者狀態過濾',
      },
      indexMergeDatePicker: {
        selectStartDate: '选择开始日期',
        selectEndDate: '选择结束日期',
      }
    }
  },
  leads: {
    seeHowToUse: '查看如何使用',
    help: '帮助',
    visitorName: '访客姓名',
    email: '电子邮件',
    phoneNumber: '电话号码',
    assignedTo: '分配给',
    status: '状态',
    tag: '标签',
    action: '操作',
    discard: '丢弃',
    addTag: '添加标签',
    loadMore: '加载更多',
    nA: '无',
    deleteUsers: '删除用户',
    areYouSureToDeleteLead: '您确定要删除此潜在客户吗？',
    twilioIntegrationNeeded: '需要Twilio集成',
    twilioIntegrationNeededDescription: 'Twilio目前未连接到您的收件箱。请进行集成以致电您的客户。',
    call: '呼叫',
    twilioMakeCall: 'Twilio已成功集成。您现在可以拨打用户的电话。',
    makeACall: '拨打电话',
    integrateNow: '立即集成',
    subscribeUser: '訂閱用戶',
    unsubscribeUser: '取消訂閱用戶',
    copy: '複製',
    noDataFound: {
      youDoNotHaveAnyChatsYet: '您还没有任何聊天',
      allOfYourChatsAppearHere: '您的所有聊天将显示在此处',
    },
    placeholders: {
      searchAgentByName: '按代理名搜索',
      searchStatusByName: '按状态名搜索',
      searchOrAddTag: '搜索或添加标签',
    }
  },
  messages: {
    seeHowToUse: '查看如何使用',
    help: '帮助',
    editChatFlow: '编辑聊天流程',
    connect: '连接',
    chat: {
      photo: '照片',
      video: '视频',
      document: '文档',
      location: '位置',
      assignedTo: '分配给',
      selectBot: '选择机器人',
      discard: '丢弃',
      addTag: '添加标签',
      yourBrowserDoesNotSupportVideoTag: '您的浏览器不支持视频标签。',
      userHasSharedADocument: '用户共享了一个文档。',
      clickHereToDownload: '点击这里下载',
      thisStoryIsNoLongerAvailable: '此故事不再可用',
      yourBrowserDoesNotSupportAudioElement: '您的浏览器不支持音频元素。',
      thisMessageIsNoLongerAvailable: '此消息不再可用，因为发送者已删除。',
      userHasSharedHisLocation: '用户已共享他的位置。点击这里查看',
      sms: '短信',
      failed: '失败',
      a: 'A',
      i: 'I',
      r: 'R',
      m: 'M',
      conversationsSelected: '选定的对话',
      nA: '不适用',
      assignTagsCloseOrBulkReply: '分配标签，关闭或批量回复所有对话',
      twilioIntegrationNeeded: '需要Twilio集成',
      twilioIntegrationNeededDescription: 'Twilio当前未连接到您的收件箱。请进行集成以呼叫您的客户。',
      call: '呼叫',
      twilioMakeCall: 'Twilio已成功集成。您现在可以呼叫用户。',
      makeACall: '拨打电话',
      integrateNow: '立即集成',
      appTooltip: {
        callUser: '呼叫用户',
        assignAgent: '分配代理',
        selectBot: '选择机器人',
        assignTagsToManageLeads: '分配标签以管理潜在客户和对话',
      },
      placeholders: {
        searchAgentByName: '按姓名搜索代理',
        searchBotByName: '按名称搜索机器人',
        searchOrAddTag: '搜索或添加标签',
        searchStatusByName: '按名称搜索状态',
      }
    },
    profile: {
      userDetails: '用户详情',
      orderDetails: '订单详情',
      orderedOn: '下单日期',
      showMore: '查看更多',
      showLess: '查看更少',
      subTotal: '小计',
      nA: '不适用',
      addAWhatsappNumber: '添加WhatsApp号码',
      addTelegramUserName: '添加Telegram用户名',
      addInstagramProfileId: '添加Instagram资料ID',
      addFacebookProfileId: '添加Facebook资料ID',
      add: '添加',
      deviceProperties: '设备属性',
      privateNotes: '私人笔记',
      urlsVisited: '访问的网址',
      source: '来源 - ',
      sourceNa: '来源 - 不适用',
      medium: '媒介 - ',
      mediumNa: '媒介 - 不适用',
      campaign: '活动 - ',
      campaignNa: '活动 - 不适用',
      attributeKey: '属性键',
      attributeName: '属性名称',
      discard: '丢弃',
      addAttribute: '添加属性',
      editAttribute: '编辑属性',
      deleteAttribute: '删除属性',
      headsUp: '注意',
      areYouSureToDeleteAttribute: '确定要删除此属性吗？',
      okay: '好的',
      dataAddedToLead: '映射到API的属性将不会更新。请相应地更新API。',
      assignedOnly: '仅分配',
      allUsers: '所有用户',
      save: '保存',
      manageCustomAttributes: '管理自定义属性',
      placeholders: {
        title: '标题',
        egServices: '例如服务',
        egRequestedServices: '例如请求的服务',
        enterYourNotesHere: '在此输入您的注释...',
      },
      bpDropDown: {
        selectBot: '选择机器人',
        selectFlow: '选择流程',
        selectQuestion: '选择问题*'
      }
    },
    sendMessage: {
      send: '发送',
      sendToAllChannels: '发送到所有渠道',
      email: '电子邮件',
      whatsapp: 'WhatsApp',
      telegram: 'Telegram',
      facebook: 'Facebook',
      sendSms: '发送短信',
      addNew: '添加新的',
      addNewQuickReply: '添加新的快捷回复',
      discard: '丢弃',
      fromComputer: '从计算机',
      add: '添加',
      dragAndDropHereOr: '拖放到这里或',
      browseFiles: '浏览文件',
      caption: '标题',
      templates: '模板',
      addHeaderMedia: '添加标题媒体',
      selectFile: '选择文件',
      previousConversationClosed: '以前的对话已关闭！',
      sendTemplateMessage: '发送模板消息以重新开始对话。',
      selectTemplate: '选择模板',
      conversationLocked: '对话已锁定！',
      demoBotOnlyAllowConversations: '演示机器人仅允许与先前验证过的号码进行对话。',
      unSubscriberUser: '已退訂用戶',
      pleaseNoteEither: '請注意，該用戶已退訂或反之亦然。請強制訂閱以開始聊天。',
      subscribeAndStart: '訂閱並開始',
      placeholders: {
        searchQuickReplyByTitle: '按标题搜索快捷回复',
        addTitle: '添加标题',
        addYourRepliesHere: '在此处添加您的回复...',
        addCaption: '添加标题',
        enterValueForThisVariable: '为此变量输入值',
      },
      modal: {
        sendBulkMessages: '发送批量消息',
        send: '发送',
        description: '根据用户所属平台的类型，您的消息将被消毒并发送。' +
          '\n - 网站用户仅支持基于文本的消息 \n - WhatsApp（未订阅）联系人只能接收模板消息'
      },
      noDataFound: {
        oops: '糟糕！',
        currentlyDoesNotSupportBulkMessages: '我们目前不支持WhatsApp机器人的批量消息。请使用广播功能',
        quickReplies: '快捷回复',
        noQuickRepliesAddedYet: '尚未添加快捷回复！',
      }
    },
    userList: {
      selectAll: '全选',
      nA: '不适用',
      loadMore: '加载更多',
    }
  },
  segments: {
    seeHowToUse: '查看如何使用',
    help: '帮助',
    manageSegment: '管理组',
    manageYourSegmentsForMarketingAutomation: '管理您的组以进行营销自动化',
    createNewSegment: '创建新组',
    segmentName: '组名称',
    totalContacts: '总联系人',
    action: '操作',
    createSegmentButton: '创建组',
    deleteSegments: '删除组',
    areYouSureToDeleteSegment: '确定要删除此组吗？',
    placeholders: {
      searchHere: '在此搜索',
    },
    noDataFound: {
      youDoNotHaveAnySegmentYet: '您尚未创建任何组',
      allYourSegmentsAppearHere: '您的所有组都将显示在这里'
    },
    modal: {
      exportData: '导出数据',
      exportDataBasedOnAppliedFilters: '根据应用的筛选条件导出数据',
      export: '导出',
    },
    appTooltip: {
      deleteSegments: '删除组',
      editSegment: '编辑组',
      downloadSegment: '下载组',
      deleteSegment: '删除组'
    },
    createSegment: {
      createSegment: '创建组',
      manageYourSegmentsForMarketingAutomation: '管理您的组以进行营销自动化',
      segmentName: '组名称',
      segmentNameIsRequired: '组名称是必需的',
      selectContactsFilterForSegment: '为组选择联系人筛选条件',
      filterYourContacts: '筛选您的联系人',
      removeAllFilters: '删除所有筛选条件',
      addFilters: '添加筛选条件',
      discard: '丢弃',
      filterSelected: '已选择筛选条件',
      placeholders: {
        enterSegmentName: '输入组名称',
      }
    }
  },
  orders: {
    visitorName: '访客姓名',
    email: '电子邮件',
    phoneNumber: '电话号码',
    status: '状态',
    itemCount: '商品数量',
    total: '总计',
    tag: '标签',
    noDataFound: {
      youDoNotHaveAnyOrdersYet: '您尚未有任何订单',
      allOfYourOrdersAppearHere: '您的所有订单将显示在这里'
    },
  }
};
